module.exports = "../images/fishing-lodge-2-5.jpg?v=9b92c6e";